import AuthProvider from "@/components/Provider/AuthProvider";
import { VStack } from "goi_common";
import FacilityMatchRequestSection from "./components/MatchRequest/FacilityMatchRequestSection";

export default function MatchFacilityMatchRequestContainer() {
  return (
    <AuthProvider redirectToIfNotLoggedIn="/match/request/">
      <VStack alignItems="center">
        <VStack id="wrapper" width="100%" maxWidth="480px">
          <FacilityMatchRequestSection />
        </VStack>
      </VStack>
    </AuthProvider>
  );
}
